// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__17Jfe","inner":"Footer_inner__dv-Ln","nextIcon":"Footer_nextIcon__AV01F","innerLeft":"Footer_innerLeft__3Ws3q"};